export default "__VITE_ASSET__5be12ac0__"